import {choice} from 'constants/url';
import useUpdate from '../../../components/hooks/useUpdate';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateChoice() {
  const updateChoice = useUpdate(choice);
  return (editingOptions: EditingOptions) => updateChoice(editingOptions);
}

export default useUpdateChoice;
